import * as React from "react"

export default function useMegaMenuItems(
  megaMenuConfig: any,
  activeMenuTab: string | undefined,
  setActiveMenuTab: (s: string | undefined) => void
) {
  return React.useMemo(() => {
    if (!megaMenuConfig) {
      return []
    }

    return megaMenuConfig.types.map((type: string) => {
      const typeData = megaMenuConfig.typeData[type]
      const item: any = { label: typeData.label, slug: type }
      if (typeData.link) {
        item.link = typeData.link
      } else {
        item.onClick = () =>
          setActiveMenuTab(activeMenuTab === type ? undefined : type)
      }
      return item
    })
  }, [megaMenuConfig, activeMenuTab, setActiveMenuTab])
}
